
import Cribbage from '../../../CribbageCore/src/Game/Cribbage.js'

import PIXI from '../GameEngine/pixi.js';
import Card from '../Sprites/Card.js'
import Cards from '../Sprites/Cards.js'
import Button from '../Sprites/ButtonSolid.js'
import ButtonSmall from '../Sprites/ButtonSmall.js'
import PopUpMessage from '../Sprites/PopUpMessage.js'
import ScoreBoard from '../Sprites/ScoreBoard.js'
import PlayerScoreBoard from '../Sprites/PlayerScoreBoard.js'
import PlayerScoreBoardMini from '../Sprites/PlayerScoreBoardMini.js'
import RoundSummaryWindow from '../Sprites/RoundSummaryWindow.js'
import MatchSummary from '../Sprites/MatchSummaryWindow.js'
import RoundSummaryTall from '../Sprites/RoundSummaryTall.js'
import HandAnalyzerPanel from '../Sprites/HandAnalyzerPanel.js'
import ScoreDetails from '../Sprites/ScoreDetails.js'
import GameOver from '../Sprites/GameOver.js'
import TurnIndicator from '../Sprites/TurnIndicator.js'
import CribbageBoard from '../Sprites/CribbageBoard.js'
import TurnTimer from '../Sprites/TurnTimer.js'
import DialogBox from '../Sprites/DialogBox.js'
import ChatBubble from '../Sprites/ChatBubble.js'
import ChatSelection from '../Sprites/ChatSelection.js'

import PileLayoutLandscapeSideCrib from './Layouts/LayoutLandscapeSideCrib.js';
import PileLayoutLandscapeSideCribFliped from './Layouts/LayoutLandscapeSideCribFliped.js';
import PileLayoutLandscapeSideCribTest from './Layouts/LayoutLandscapeSideCribTest.js';
import PileLayoutLandscapeSideCribSpectate from './Layouts/LayoutLandscapeSideCribSpectate.js';

export default class GameScene {
    constructor(app, cribbage, audio) {
        this.app = app || {};
        this.audio = audio;
        this.stageWidth = 800;
        this.stageHeight = 500;
        //this.loader = new PIXI.Loader();
        this.isLoaded = false;
        this.stage = new PIXI.Container();
        this.cribbage = cribbage;
        this.tablePosition = "player1";
        this.isChatMuted = false;
        this.isAudioMuted = this.app.isMuted;
        this.debug = false;
        this.isCreated = false;
        this.currentState = null;

        //eventListeners
        this.onCardMovedEventListener = this.onCardMoved.bind(this);
        this.onStateChangedEventListener = this.onStateChanged.bind(this);
        this.onActionStartEventListener = this.onActionStart.bind(this);
        this.onActionEndedEventListener = this.onActionEnded.bind(this);
        this.onAwardPointsEventListener = this.onAwardPoints.bind(this);
        this.onHandPointsEventListener = this.onHandPoints.bind(this);
        this.onMatchPointsEventListener = this.onMatchPoints.bind(this);
        this.onMessageEventListener = this.onMessage.bind(this);
        this.onInvalidMoveEventListener = this.onInvalidMove.bind(this);
        this.onJoinEventListener = this.onJoin.bind(this);
        this.onLeaveEventListener = this.onLeave.bind(this);
        this.onDisconnectEventListener = this.onDisconnect.bind(this);
        this.onStartPlayTimerEventListener = this.onStartPlayTimer.bind(this);
        this.onChatEventListener = this.onChat.bind(this);
        this.onDataEventListener = this.onData.bind(this);
        this.onCardMovedEventListener = this.onCardMoved.bind(this);


        //todo: remove all ties to "app" and just send events 

        this.pileLayoutLandscapeSideCrib = PileLayoutLandscapeSideCrib;
        this.pileLayoutLandscapeSideCribFliped = PileLayoutLandscapeSideCribFliped; 
        this.pileLayoutLandscapeSideCribTest = PileLayoutLandscapeSideCribTest; 
        this.pileLayoutLandscapeSideCribSpectate = PileLayoutLandscapeSideCribSpectate;


        this.pileLayout = this.pileLayoutLandscapeSideCrib;
    }
    init(cribbage, tablePosition, lastPage) {
        if (cribbage) {
            this.cribbage = cribbage;
        }
        if (!this.cribbage) {
            this.cribbage = new Cribbage();
            this.cribbage.debug = true;
        }
        this.debug = this.cribbage.debug;
        this.isChatMuted = this.cribbage.isChatMuted;
        this.board = this.cribbage.boardName;
        this.deck = this.cribbage.deck;
        if (this.gameOver) this.gameOver.visible = false;
        //if (this.roundSummary) this.roundSummary.visible = false;
        if (this.handAnalyzerPanel) this.handAnalyzerPanel.visible = false;

        this.cribbage.event.addListener("cardMoved", this.onCardMovedEventListener);
        this.cribbage.event.addListener("stateChange", this.onStateChangedEventListener);
        this.cribbage.event.addListener("action", this.onActionStartEventListener);
        this.cribbage.event.addListener("actionEnded", this.onActionEndedEventListener);
        this.cribbage.event.addListener("awardPointArray", this.onAwardPointsEventListener);
        this.cribbage.event.addListener("handPoints", this.onHandPointsEventListener);
        this.cribbage.event.addListener("matchPoints", this.onMatchPointsEventListener);
        this.cribbage.event.addListener("message", this.onMessageEventListener);
        this.cribbage.event.addListener("invalidMove", this.onInvalidMoveEventListener);
        this.cribbage.event.addListener("join", this.onJoinEventListener);
        this.cribbage.event.addListener("leave", this.onLeaveEventListener);
        this.cribbage.event.addListener("disconnect", this.onDisconnectEventListener);
        this.cribbage.event.addListener("startPlayTimer", this.onStartPlayTimerEventListener);
        this.cribbage.event.addListener("chat", this.onChatEventListener);
        this.cribbage.event.addListener("data", this.onDataEventListener);

        this.lastPage = lastPage;
        // if (localUserName) this.localUserName = localUserName;
        // if(this.cribbage.player1 && this.localUserName === this.cribbage.player1.name){
        //     this.localPlayer = "player1";
        // }
        // if(this.cribbage.player2 && this.localUserName === this.cribbage.player2.name){
        //     this.localPlayer = "player2";
        // }

        //if (tablePosition) this.tablePosition = tablePosition;
        this.tablePosition = tablePosition;


        this.pileLayout = this.getLayout(this.tablePosition);

        //    // if (this.debug)
        //    if(this.debug || this.cribbage && this.cribbage.debug )
        //         this.pileLayout = this.pileLayoutLandscapeSideCribTest;  
    }
    getLayout(tablePosition) {
        if (tablePosition === "player1")
            return this.pileLayoutLandscapeSideCrib;
        else if (tablePosition === "player2")
            return this.pileLayoutLandscapeSideCribFliped;
        else if (tablePosition === "test")
            return this.pileLayoutLandscapeSideCribTest;
        else
            return this.pileLayoutLandscapeSideCribSpectate;
    }
    reload(cribbage, tablePosition, lastPage) {
        this.shutdown(); //added as it may not have shut down before
        this.init(cribbage, tablePosition, lastPage);
        //skip create()
        this.updateLayout();
        this.onStateChanged();
    }
    shutdown() {
        //cleaup  this.cribbage 
        //this.cribbage.destroy();
        if (this.cribbage) {
            // this.cribbage.event.removeAllListener();
            this.cribbage.event.removeListener("cardMoved", this.onCardMovedEventListener);
            this.cribbage.event.removeListener("stateChange", this.onStateChangedEventListener);
            this.cribbage.event.removeListener("action", this.onActionStartEventListener);
            this.cribbage.event.removeListener("actionEnded", this.onActionEndedEventListener);
            this.cribbage.event.removeListener("awardPointArray", this.onAwardPointsEventListener);
            this.cribbage.event.removeListener("handPoints", this.onHandPointsEventListener);
            this.cribbage.event.removeListener("matchPoints", this.onMatchPointsEventListener);
            this.cribbage.event.removeListener("message", this.onMessageEventListener);
            this.cribbage.event.removeListener("invalidMove", this.onInvalidMoveEventListener);
            this.cribbage.event.removeListener("join", this.onJoinEventListener);
            this.cribbage.event.removeListener("leave", this.onLeaveEventListener);
            this.cribbage.event.removeListener("disconnect", this.onDisconnectEventListener);
            this.cribbage.event.removeListener("startPlayTimer", this.onStartPlayTimerEventListener);
            this.cribbage.event.removeListener("chat", this.onChatEventListener);
            this.cribbage.event.removeListener("data", this.onDataEventListener);

        }
        this.cribbage = new Cribbage();
        this.updateLayout();
    }
    destroy() {
        this.isDestroyed = true;
        this.shutdown();
        if (this.stage) {
            this.stage.destroy({ children: true, texture: true, baseTexture: true });
        }
        this.stage = null;
        this.app = null;
        this.cribbage = null;
    }
    preload(callback) {
        //todo: load all
        //todo: pass loader in change PIXI.Loader.shared -> this.loader

        var loader = PIXI.Loader.shared;


        //buttons
        loader.add("BackButton", "assets/Buttons/BackButton.png");
        loader.add("ChatButton", "assets/Buttons/ChatButton.png");
        loader.add("AddFriendButton", "assets/Buttons/AddFriend.png");
        loader.add("AudioButton", "assets/Buttons/AudioButton.png");
        loader.add("AudioMuteButton", "assets/Buttons/AudioMuteButton.png");
        //Blank button
        //loader.add("ButtonBlankShadow", "assets/Buttons/ButtonBlankShadow.png");

        //avatar
        loader.add("Avatar", "assets/Avatars/agent.png");
        loader.add("Avatar_Computer", "assets/Avatars/default-avatar.png");
        loader.add("Avatar_Disconnected", "assets/Avatars/disconnected.png");
        loader.add("disconnected", "assets/Game/disconnected.png");
        loader.add("chatMute", "assets/Game/microphoneMute.png");

        //game
        //loader.add("assets/Decks/PirateDeck200_SpriteSheet@2x.json");
        //loader.add("assets/Decks/DualSideDeck_SpriteSheet.json");
        //loader.add("assets/Decks/PixaromaDeck_SpriteSheet.json");
        loader.add("Deck", "assets/Decks/PixaromaDeck_SpriteSheet.json");   //cards
        //backgrounds
        loader.add("WoodBackground", "assets/Backgrounds/WoodBackground.png");
        loader.add("BlueBackground", "assets/Backgrounds/BlueBackground.png");
        loader.add("GreenBackground", "assets/Backgrounds/GreenBackground.png");
        loader.add("GreenLightBackground", "assets/Backgrounds/GreenLightBackground.png");
        loader.add("RedBackground", "assets/Backgrounds/RedBackground.png");
        //loader.add("FantasyBackground", "assets/Backgrounds/FantasyBackground.png");
        //loader.add("TrainBackground", "assets/Backgrounds/TrainBackground.png");

        // loader.add("MicrophoneButton", "assets/Game/Microphone.png");
        // loader.add("MicrophoneMuteButton", "assets/Game/MicrophoneMute.png");
        loader.add("peg1", "assets/CribbageBoards/Peg_Blue.png");
        loader.add("peg2", "assets/CribbageBoards/Peg_Red.png");

        loader.add("assets/Badges/Badges.json");
        //cribbage board
        loader.add("CribbageBoard", "assets/CribbageBoards/CribbageBoard_Tall_Wood_RedBlue.png");

        //sounds
        //https://pixijs.io/pixi-sound/docs/PIXI.sound.html

        // loader.add('CardClick', 'assets/Audio/click_lower_volumn.wav');
        // loader.add('PointSound', 'assets/Audio/whoop.wav');
        // loader.add('AchivementSound', 'assets/Audio/chime.wav');
        // loader.add('WinSound', 'assets/Audio/win.wav');
        loader.load((loader, resources) => {
            this.create();
            this.isLoaded = true;
            if (callback) callback(loader, resources);
        });
    }
    create() {

        //this.cardUIs = [];
        //let blength = PIXI.utils.BaseTextureCache;
        //todo: new PIXI.Text( is creating a new texture each time the game is loaded

        //background
        let textureBackground = PIXI.Loader.shared.resources['WoodBackground'].texture;
        this.background = new PIXI.Sprite(textureBackground);
        this.background.width = this.stageWidth + 200;
        this.background.height = this.stageHeight + 200;
        this.background.x = -100;
        this.background.y = -100;
        this.background.zOrder = -100;
        this.stage.addChild(this.background);



        //exit button
        var buttonExit = new PIXI.Sprite(PIXI.Loader.shared.resources['BackButton'].texture);
        buttonExit.x = 10;
        buttonExit.y = 10;
        buttonExit.width = 60;
        buttonExit.height = 60;
        buttonExit.interactive = true;
        buttonExit.on('pointerdown', this.buttonExit_onClick.bind(this));
        this.stage.addChild(buttonExit);


        //add audio mute toggle button 
        this.buttonAudio = new PIXI.Sprite(PIXI.Loader.shared.resources['AudioButton'].texture);
        this.buttonAudio.x = 10
        this.buttonAudio.y = 10 + (70 * 1);
        this.buttonAudio.width = 60;
        this.buttonAudio.height = 60;
        this.buttonAudio.interactive = true;
        this.buttonAudio.on('pointerdown', this.buttonMute_onClick.bind(this));
        this.stage.addChild(this.buttonAudio);

        //add audio mute toggle button 
        this.buttonAudioMute = new PIXI.Sprite(PIXI.Loader.shared.resources['AudioMuteButton'].texture);
        this.buttonAudioMute.x = 10
        this.buttonAudioMute.y = 10 + (70 * 1);
        this.buttonAudioMute.width = 60;
        this.buttonAudioMute.height = 60;
        this.buttonAudioMute.interactive = true;
        this.buttonAudioMute.visible = false;
        this.buttonAudioMute.on('pointerdown', this.buttonMute_onClick.bind(this));
        this.stage.addChild(this.buttonAudioMute);


        //chat button 
        this.buttonChat = new PIXI.Sprite(PIXI.Loader.shared.resources['ChatButton'].texture);
        this.buttonChat.x = 10
        this.buttonChat.y = this.stageHeight - 70;
        this.buttonChat.width = 60;
        this.buttonChat.height = 60;
        this.buttonChat.interactive = true;
        this.buttonChat.on('pointerdown', this.buttonChat_onClick.bind(this));
        this.stage.addChild(this.buttonChat);



        //create CribbageBoard
        this.cribbageBoard = new CribbageBoard(this.cribbage.boardName);
        this.cribbageBoard.x = this.pileLayout["cribbageboard"].x;
        this.cribbageBoard.y = this.pileLayout["cribbageboard"].y;
        // this.cribbageBoard.scale.x = this.cribbageBoard.scale.y= this.pileLayout["cribbageboard"].scale;
        if (this.pileLayout["cribbageboard"].scale)
            this.cribbageBoard.scale.x = this.pileLayout["cribbageboard"].scale;
        if (this.pileLayout["cribbageboard"].width)
            this.cribbageBoard.cribbageBoard_width = this.pileLayout["cribbageboard"].width;
        if (this.pileLayout["cribbageboard"].height)
            this.cribbageBoard.cribbageBoard_height = this.pileLayout["cribbageboard"].height;
        if (this.pileLayout["cribbageboard"].r) {
            this.cribbageBoard.rotation = this.pileLayout["cribbageboard"].r;
            //bunny.anchor.set(0.5);
        }
        // this.cribbageBoard.scale.x = 0.9;
        // this.cribbageBoard.scale.y = 0.9;
        this.cribbageBoard.zOrder = -90;
        this.stage.addChild(this.cribbageBoard);
        this.cribbageBoard.updateLayout();

        //playPileBackground playBackground
        //x: 625, y: 250
        this.playPile = new PIXI.Graphics();
        this.playPile.beginFill(0x000000);
        //this.playPile.drawRect(575,180 , 200, 140);
        this.playPile.drawRoundedRect(
            this.pileLayout["playBackground"].x,
            this.pileLayout["playBackground"].y,
            this.pileLayout["playBackground"].width,
            this.pileLayout["playBackground"].height,
            10);
        this.playPile.alpha = 0.3;
        this.playPile.zOrder = -90;
        this.stage.addChild(this.playPile);




        //Player scoreboard 1
        this.player1Scoreboard = new PlayerScoreBoard("", "", 0x479ACE);
        if (this.cribbage.player1)
            this.player1Scoreboard.name = this.cribbage.player1.name;
        else
            this.player1Scoreboard.name = "";
        this.player1Scoreboard.x = this.pileLayout["profile1"].x;
        this.player1Scoreboard.y = this.pileLayout["profile1"].y;
        this.player1Scoreboard.zOrder = -80;
        this.player1Scoreboard.interactive = true;
        this.player1Scoreboard.on('pointerdown', this.player1Scoreboard_onClick.bind(this));
        this.stage.addChild(this.player1Scoreboard);

        //Player scoreboard 2
        this.player2Scoreboard = new PlayerScoreBoard("", "", 0xC03500);
        if (this.cribbage.player2)
            this.player2Scoreboard.name = this.cribbage.player2.name;
        else
            this.player2Scoreboard.name = "";
        this.player2Scoreboard.x = this.pileLayout["profile2"].x;
        this.player2Scoreboard.y = this.pileLayout["profile2"].y;
        this.player2Scoreboard.zOrder = -80;
        this.player2Scoreboard.interactive = true;
        this.player2Scoreboard.on('pointerdown', this.player2Scoreboard_onClick.bind(this));
        this.stage.addChild(this.player2Scoreboard);

        //Disconnected indicator 1
        this.player1Disconnected = new PIXI.Sprite(PIXI.Loader.shared.resources['disconnected'].texture);
        this.player1Disconnected.x = this.pileLayout["profile1"].x;
        this.player1Disconnected.y = this.pileLayout["profile1"].y;
        this.player1Disconnected.width = 30;
        this.player1Disconnected.height = 30;
        this.stage.addChild(this.player1Disconnected);

        //Disconnected indicator 2
        this.player2Disconnected = new PIXI.Sprite(PIXI.Loader.shared.resources['disconnected'].texture);
        this.player2Disconnected.x = this.pileLayout["profile2"].x;
        this.player2Disconnected.y = this.pileLayout["profile2"].y;
        this.player2Disconnected.width = 30;
        this.player2Disconnected.height = 30;
        this.stage.addChild(this.player2Disconnected);

        //ChatMute indicator (always top)
        this.chatMute = new PIXI.Sprite(PIXI.Loader.shared.resources['chatMute'].texture);
        this.chatMute.x = 80;
        this.chatMute.y = 120;
        this.chatMute.width = 30;
        this.chatMute.height = 30;
        this.stage.addChild(this.chatMute);

        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });

        //addFriendButton background
        var addFriendButtonOutline = new PIXI.Graphics();
        //addFriendButtonOutline.lineStyle(1, 0xFFFFFF, 1);
        addFriendButtonOutline.beginFill(0x218414);
        addFriendButtonOutline.drawRoundedRect(80, 153, 50, 18, 5);
        this.stage.addChild(addFriendButtonOutline);

        //addFriendButton indicator (always top)
        this.addFriendButton = new PIXI.Text("+Friend", styleSmall);
        this.addFriendButton.x = 105;
        this.addFriendButton.y = 155;
        this.addFriendButton.scale.set(0.5);
        this.addFriendButton.anchor.set(0.5, 0);
        this.addFriendButton.interactive = true;
        this.addFriendButton.on('pointerdown', this.buttonAddFriend_onClick.bind(this));
        this.stage.addChild(this.addFriendButton);

        //ReportButton background
        var reportButtonOutline = new PIXI.Graphics();
        // reportButtonOutline.lineStyle(1, 0xFFFFFF, 1);
        reportButtonOutline.beginFill(0xC03510);
        reportButtonOutline.drawRoundedRect(135, 153, 45, 18, 5);
        this.stage.addChild(reportButtonOutline);

        //ReportButton indicator (always top)
        this.reportButton = new PIXI.Text("Block", styleSmall);
        this.reportButton.x = 157;
        this.reportButton.y = 155;
        this.reportButton.scale.set(0.5);
        this.reportButton.anchor.set(0.5, 0);
        this.reportButton.interactive = true;
        this.reportButton.on('pointerdown', this.reportButton_onClick.bind(this));
        this.stage.addChild(this.reportButton);


        //player1TurnTimer
        this.player1TurnTimer = new TurnTimer();
        this.player1TurnTimer.x = this.pileLayout["profile1"].x;
        this.player1TurnTimer.y = this.pileLayout["profile1"].y + 100;
        this.stage.addChild(this.player1TurnTimer);

        //player2TurnTimer
        this.player2TurnTimer = new TurnTimer();
        this.player2TurnTimer.x = this.pileLayout["profile2"].x;
        this.player2TurnTimer.y = this.pileLayout["profile2"].y + 100;
        this.stage.addChild(this.player2TurnTimer);


        //TurnIndicator 1
        this.player1TurnIndicator = new TurnIndicator(0x479ACE);
        this.player1TurnIndicator.x = this.pileLayout["profile1"].x;
        this.player1TurnIndicator.y = this.pileLayout["profile1"].y;
        this.player1TurnIndicator.zOrder = -70;
        this.stage.addChild(this.player1TurnIndicator);


        //TurnIndicator 2
        this.player2TurnIndicator = new TurnIndicator(0xC03500);
        this.player2TurnIndicator.x = this.pileLayout["profile2"].x;
        this.player2TurnIndicator.y = this.pileLayout["profile2"].y;
        this.player2TurnIndicator.zOrder = -70;
        this.stage.addChild(this.player2TurnIndicator);



        // this.tilingSprite = new PIXI.extras.TilingSprite(textureBackground, 2000, 2000);
        // this.tilingSprite.x = -500;
        // this.tilingSprite.y = -500;
        // this.stage.addChild(this.tilingSprite);



        //create text style
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 36,
            fontStyle: 'italic',
            fontWeight: 'bold',
            fill: ['#ffffff', '#00ff99'], // gradient
            stroke: '#4a1850',
            strokeThickness: 5,
            dropShadow: true,
            dropShadowColor: '#000000',
            dropShadowBlur: 4,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 6,
            wordWrap: true,
            wordWrapWidth: 440
        });
        var stylePlayCount = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 100,
            fill: '#FFFFFF',
            align: 'center'
        });
        var styleInstructions = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40,
            fill: '#FFFFFF',
            wordWrapWidth: 800,
            align: 'center'
        });
        //create text for play count
        this.textPlayCount = new PIXI.Text('', stylePlayCount);
        this.textPlayCount.x = this.pileLayout["playcount"].x;
        this.textPlayCount.y = this.pileLayout["playcount"].y;
        this.textPlayCount.zOrder = 100;
        this.textPlayCount.anchor.set(0.5, 0);
        this.textPlayCount.scale.set(0.5);
        this.stage.addChild(this.textPlayCount);

        // //create text - state
        // this.textState = new PIXI.Text('Current State', styleLarge);
        // this.textState.x = 20;
        // this.textState.y = -50;
        // this.stage.addChild(this.textState);

        //instructions Bottom
        this.textInstructionsBottom = new PIXI.Text('', styleInstructions);
        this.textInstructionsBottom.x = this.pileLayout["instructions1"].x;
        this.textInstructionsBottom.y = this.pileLayout["instructions1"].y;
        this.textInstructionsBottom.zOrder = 100;
        this.textInstructionsBottom.scale.set(0.5);
        this.textInstructionsBottom.anchor.set(0.5, 0);
        this.stage.addChild(this.textInstructionsBottom);

        //instructions Top
        this.textInstructionsTop = new PIXI.Text('', styleInstructions);
        this.textInstructionsTop.x = this.pileLayout["instructions2"].x;
        this.textInstructionsTop.y = this.pileLayout["instructions2"].y;
        this.textInstructionsTop.zOrder = 100;
        this.textInstructionsTop.scale.set(0.5);
        this.textInstructionsTop.anchor.set(0.5, 0);
        this.stage.addChild(this.textInstructionsTop);

        //invalid move text Bottom
        this.textInvalidMoveBottom = new PIXI.Text('', styleInstructions);
        this.textInvalidMoveBottom.x = this.pileLayout["invalidMove1"].x;
        this.textInvalidMoveBottom.y = this.pileLayout["invalidMove1"].y;
        this.textInvalidMoveBottom.zOrder = 100;
        this.textInvalidMoveBottom.scale.set(0.5);
        this.textInvalidMoveBottom.anchor.set(0.5, 0);
        this.stage.addChild(this.textInvalidMoveBottom);

        //invalid move text Top
        this.textInvalidMoveTop = new PIXI.Text('', styleInstructions);
        this.textInvalidMoveTop.x = this.pileLayout["invalidMove2"].x;
        this.textInvalidMoveTop.y = this.pileLayout["invalidMove2"].y;
        this.textInvalidMoveTop.zOrder = 100;
        this.textInvalidMoveTop.scale.set(0.5);
        this.textInvalidMoveTop.anchor.set(0.5, 0);
        this.stage.addChild(this.textInvalidMoveTop);

        //cards
        this.cardsUI = new Cards(this.cribbage.cards);
        this.cardsUI.zOrder = 100;
        this.cardsUI.cardTouched = this.onCardTouched.bind(this);
        this.stage.addChild(this.cardsUI);
        //force card to move to position
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);


        //hand score button
        this.btnScoreHand1 = new ButtonSmall("5 🔎", 0x479ACE, 100);
        this.btnScoreHand1.interactive = true;
        this.btnScoreHand1.visible = false;
        this.btnScoreHand1.on('pointerdown', this.btnHand1_onClick.bind(this));
        this.stage.addChild(this.btnScoreHand1);

        //hand score button
        this.btnScoreHand2 = new ButtonSmall("5 🔎", 0xC03500, 100);
        this.btnScoreHand2.interactive = true;
        this.btnScoreHand2.visible = false;
        this.btnScoreHand2.on('pointerdown', this.btnHand2_onClick.bind(this));
        this.stage.addChild(this.btnScoreHand2);

        //hand crib score button
        this.btnScoreCrib1 = new ButtonSmall("5 🔎", 0x479ACE, 100);
        this.btnScoreCrib1.interactive = true;
        this.btnScoreCrib1.visible = false;
        this.btnScoreCrib1.on('pointerdown', this.btnCrib1_onClick.bind(this));
        this.stage.addChild(this.btnScoreCrib1);

        //hand crib score button
        this.btnScoreCrib2 = new ButtonSmall("5 🔎", 0xC03500, 100);
        this.btnScoreCrib2.interactive = true;
        this.btnScoreCrib2.visible = false;
        this.btnScoreCrib2.on('pointerdown', this.btnCrib2_onClick.bind(this));
        this.stage.addChild(this.btnScoreCrib2);

        //sort button
        this.btnSort = new Button("Sort", 0x999999);
        this.btnSort.x = 265;
        this.btnSort.y = 220;
        this.btnSort.interactive = true;
        this.btnSort.visible = false;
        this.btnSort.on('pointerdown', this.btnSort_onClick.bind(this));
        this.stage.addChild(this.btnSort);

        //confirm button
        this.btnConfirm = new Button("Confirm", 0x479ACE);
        this.btnConfirm.x = 265;
        this.btnConfirm.y = 220;
        this.btnConfirm.interactive = true;
        this.btnConfirm.visible = false;
        this.btnConfirm.on('pointerdown', this.btnConfirm_onClick.bind(this));
        this.stage.addChild(this.btnConfirm);

        //start button
        this.btnReady = new Button("Ready", 0x479ACE);
        this.btnReady.x = 265;
        this.btnReady.y = 220;
        this.btnReady.interactive = true;
        this.btnReady.visible = false;
        this.btnReady.on('pointerdown', this.btnReady_onClick.bind(this));
        this.stage.addChild(this.btnReady);

        //create pop up message for points
        this.textPopUpMessageBottom = new PopUpMessage();
        this.textPopUpMessageBottom.x = this.pileLayout["pointPopup1"].x;
        this.textPopUpMessageBottom.y = this.pileLayout["pointPopup1"].y;
        this.textPopUpMessageBottom.zOrder = 200;
        this.stage.addChild(this.textPopUpMessageBottom);

        //create pop up message for points
        this.textPopUpMessageTop = new PopUpMessage();
        this.textPopUpMessageTop.x = this.pileLayout["pointPopup2"].x;
        this.textPopUpMessageTop.y = this.pileLayout["pointPopup2"].y;
        this.textPopUpMessageTop.zOrder = 200;
        this.stage.addChild(this.textPopUpMessageTop);

        //ChatSelection popup
        this.chatSelection = new ChatSelection("");
        this.chatSelection.x = (this.stageWidth / 2);
        this.chatSelection.y = (this.stageHeight / 2);
        this.chatSelection.visible = false;
        this.chatSelection.zOrder = 200;
        this.chatSelection.onSelect = this.chatSelection_onSelect.bind(this);
        this.stage.addChild(this.chatSelection);

        //Game over popup
        this.gameOver = new GameOver();
        this.gameOver.x = (this.stageWidth / 2);
        this.gameOver.y = (this.stageHeight / 2);
        this.gameOver.visible = false;
        this.gameOver.zOrder = 200;
        this.gameOver.onClose = this.gameOver_onClick.bind(this);
        this.gameOver.onRematch = this.gameOver_onRematch.bind(this);
        this.gameOver.onDetails = this.gameOver_onDetails.bind(this);
        this.stage.addChild(this.gameOver);


        //RoundSummary
        this.roundSummary = new RoundSummaryTall();
        this.roundSummary.x = 190;
        this.roundSummary.y = 420;
        this.roundSummary.visible = false;
        this.roundSummary.zOrder = 200;
        this.roundSummary.onExplain = this.showRoundDetails.bind(this);
        this.roundSummary.onNext = this.btnNext_onClick.bind(this);
        this.roundSummary.onAnalyze = this.showAnalyzeHand.bind(this);
        this.stage.addChild(this.roundSummary);


        this.handAnalyzerPanel = new HandAnalyzerPanel();
        this.handAnalyzerPanel.visible = false;
        this.handAnalyzerPanel.interactive = true;
        this.handAnalyzerPanel.on('pointerdown', this.btnAnalyzeHand_onClick.bind(this));
        this.stage.addChild(this.handAnalyzerPanel);




        //ChatBubble 1
        this.player1ChatBubble = new ChatBubble('');
        this.player1ChatBubble.x = this.pileLayout["chatBubble1"].x;
        this.player1ChatBubble.y = this.pileLayout["chatBubble1"].y;
        this.player1ChatBubble.zOrder = 210;
        this.stage.addChild(this.player1ChatBubble);

        //ChatBubble 2
        this.player2ChatBubble = new ChatBubble('');
        this.player2ChatBubble.x = this.pileLayout["chatBubble2"].x;
        this.player2ChatBubble.y = this.pileLayout["chatBubble2"].y;
        this.player2ChatBubble.zOrder = 210;
        this.stage.addChild(this.player2ChatBubble);


        //click anywhere
        this.stage.interactive = true;
        this.stage.on('pointerdown', this.onClick.bind(this));

        this.updateLayout();

        this.start();
        this.isCreated = true;
    }
    updateLayout() {

        this.pileLayout = this.getLayout(this.tablePosition);

        //todo: move to class and load dynamicly
        //background
        let resourceBackground = PIXI.Loader.shared.resources[this.cribbage.background]; //preloadded
        if (resourceBackground && resourceBackground.texture) {
            this.background.texture = resourceBackground.texture;
            this.background.width = this.stageWidth + 200;
            this.background.height = this.stageHeight + 200;
            this.background.x = -100;
            this.background.y = -100;
            this.background.zOrder = -100;
        }

        //create CribbageBoard
        this.cribbageBoard.x = this.pileLayout["cribbageboard"].x;
        this.cribbageBoard.y = this.pileLayout["cribbageboard"].y;
        // this.cribbageBoard.scale.x = this.cribbageBoard.scale.y= this.pileLayout["cribbageboard"].scale;
        if (this.pileLayout["cribbageboard"].scale)
            this.cribbageBoard.scale.x = this.pileLayout["cribbageboard"].scale;
        if (this.pileLayout["cribbageboard"].width)
            this.cribbageBoard.cribbageBoard_width = this.pileLayout["cribbageboard"].width;
        if (this.pileLayout["cribbageboard"].height)
            this.cribbageBoard.cribbageBoard_height = this.pileLayout["cribbageboard"].height;
        if (this.pileLayout["cribbageboard"].r) {
            this.cribbageBoard.rotation = this.pileLayout["cribbageboard"].r;
        }
        this.cribbageBoard.zOrder = -90;
        this.cribbageBoard.board = this.cribbage.boardName;
        this.cribbageBoard.updateLayout();

        // //playPileBackground playBackground
        // this.playPile.x =this.pileLayout["playBackground"].x;
        // this.playPile.y =this.pileLayout["playBackground"].y;
        // this.playPile.alpha = 0.3;
        // this.playPile.zOrder = -90;



        //Player scoreboard
        if (this.cribbage.player1) {
            this.player1Scoreboard.name = this.cribbage.player1.name || "";
            this.player1Scoreboard.avatar = this.cribbage.player1.avatar;
            this.player1Scoreboard.rank = this.cribbage.player1.rank;
            // if (this.cribbage.player1.isDisconnected) {
            //     this.player1Scoreboard.avatar = "Avatar_Disconnected";
            // }
        }
        this.player1Scoreboard.x = this.pileLayout["profile1"].x;
        this.player1Scoreboard.y = this.pileLayout["profile1"].y;
        this.player1Scoreboard.zOrder = -80;
        this.player1Scoreboard.updateLayout();



        //Player scoreboard
        if (this.cribbage.player2) {
            this.player2Scoreboard.name = this.cribbage.player2.name || "";
            this.player2Scoreboard.avatar = this.cribbage.player2.avatar;
            this.player2Scoreboard.rank = this.cribbage.player2.rank;
            // if (this.cribbage.player2.isDisconnected) {
            //     this.player2Scoreboard.avatar = "Avatar_Disconnected";
            // }
        }
        this.player2Scoreboard.x = this.pileLayout["profile2"].x;
        this.player2Scoreboard.y = this.pileLayout["profile2"].y;
        this.player2Scoreboard.zOrder = -80;
        this.player2Scoreboard.updateLayout();

        //Disconnected indicator 1
        this.player1Disconnected.x = this.pileLayout["profile1"].x + 3;
        this.player1Disconnected.y = this.pileLayout["profile1"].y + 3;
        if (this.cribbage.player1) {
            let isDisconnected1 = this.cribbage.player1.isDisconnected;
            this.player1Disconnected.visible = isDisconnected1;
        }

        //Disconnected indicator 2
        this.player2Disconnected.x = this.pileLayout["profile2"].x + 3;
        this.player2Disconnected.y = this.pileLayout["profile2"].y + 3;
        if (this.cribbage.player2) {
            let isDisconnected2 = this.cribbage.player2.isDisconnected;
            this.player2Disconnected.visible = isDisconnected2;
        }

        //ChatMute indicator  
        this.chatMute.visible = this.isChatMuted;

        //Audio button
        this.buttonAudio.visible = !this.isAudioMuted;
        this.buttonAudioMute.visible = this.isAudioMuted;

        //player1TurnTimer
        this.player1TurnTimer.x = this.pileLayout["profile1"].x;
        this.player1TurnTimer.y = this.pileLayout["profile1"].y + 145;


        //player2TurnTimer
        this.player2TurnTimer.x = this.pileLayout["profile2"].x;
        this.player2TurnTimer.y = this.pileLayout["profile2"].y + 145;


        //TurnIndicator 1
        this.player1TurnIndicator.x = this.pileLayout["profile1"].x;
        this.player1TurnIndicator.y = this.pileLayout["profile1"].y;
        this.player1TurnIndicator.zOrder = -70;


        //TurnIndicator 2
        this.player2TurnIndicator.x = this.pileLayout["profile2"].x;
        this.player2TurnIndicator.y = this.pileLayout["profile2"].y;
        this.player2TurnIndicator.zOrder = -70;


        //create text for play count
        this.textPlayCount.x = this.pileLayout["playcount"].x;
        this.textPlayCount.y = this.pileLayout["playcount"].y;
        this.textPlayCount.zOrder = 100;
        this.textPlayCount.anchor.set(0.5, 0);
        this.textPlayCount.scale.set(0.5);
        this.textPlayCount.text = this.cribbage.playCount;

        //instructions Bottom
        this.textInstructionsBottom.x = this.pileLayout["instructions1"].x;
        this.textInstructionsBottom.y = this.pileLayout["instructions1"].y;
        this.textInstructionsBottom.zOrder = 100;
        this.textInstructionsBottom.scale.set(0.5);
        this.textInstructionsBottom.anchor.set(0.5, 0);
        this.textInstructionsBottom.text = this.cribbage.messagePlayer1;

        //instructions Top
        this.textInstructionsTop.x = this.pileLayout["instructions2"].x;
        this.textInstructionsTop.y = this.pileLayout["instructions2"].y;
        this.textInstructionsTop.zOrder = 100;
        this.textInstructionsTop.scale.set(0.5);
        this.textInstructionsTop.anchor.set(0.5, 0);
        this.textInstructionsTop.text = this.cribbage.messagePlayer2;

        //invalid move text Bottom
        this.textInvalidMoveBottom.x = this.pileLayout["invalidMove1"].x;
        this.textInvalidMoveBottom.y = this.pileLayout["invalidMove1"].y;
        this.textInvalidMoveBottom.zOrder = 100;
        this.textInvalidMoveBottom.scale.set(0.5);
        this.textInvalidMoveBottom.anchor.set(0.5, 0);

        //invalid move text Top
        this.textInvalidMoveTop.x = this.pileLayout["invalidMove2"].x;
        this.textInvalidMoveTop.y = this.pileLayout["invalidMove2"].y;
        this.textInvalidMoveTop.zOrder = 100;
        this.textInvalidMoveTop.scale.set(0.5);
        this.textInvalidMoveTop.anchor.set(0.5, 0);

        //force card to move to position
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);
        this.cardsUI.deck = this.cribbage.deck;
        this.cardsUI.updateLayout();

        //this.gameOver.x = (this.stageWidth / 2);
        //this.gameOver.y = (this.stageHeight / 2);
        this.gameOver.x = 195;
        this.gameOver.y = 160;
        this.gameOver.zOrder = 200;


        this.roundSummary.x = 600;
        this.roundSummary.y = 0;
        this.roundSummary.zOrder = 200;

        this.handAnalyzerPanel.x = 250;
        this.handAnalyzerPanel.y = 455;
        this.handAnalyzerPanel.zOrder = 200;
        this.handAnalyzerPanel.updateLayout();
        //could pull data here, but it should not do calculations even layout update.


        //hand score button
        this.btnScoreHand1.x = this.pileLayout["handShow1"].x - (this.btnScoreHand1.width / 2);
        this.btnScoreHand1.y = this.pileLayout["handShow1"].y + 30;

        //hand score button
        this.btnScoreHand2.x = this.pileLayout["handShow2"].x - (this.btnScoreHand2.width / 2);
        this.btnScoreHand2.y = this.pileLayout["handShow2"].y + 30;

        //hand score button
        this.btnScoreCrib1.x = this.pileLayout["cribShow1"].x - (this.btnScoreCrib1.width / 2);
        this.btnScoreCrib1.y = this.pileLayout["cribShow1"].y + 30;

        //hand score button
        this.btnScoreCrib2.x = this.pileLayout["cribShow2"].x - (this.btnScoreCrib2.width / 2);
        this.btnScoreCrib2.y = this.pileLayout["cribShow2"].y + 30;


        //ChatBubble 1
        this.player1ChatBubble.x = this.pileLayout["chatBubble1"].x;
        this.player1ChatBubble.y = this.pileLayout["chatBubble1"].y;
        //this.player1ChatBubble.stemDirection  = this.pileLayout["chatBubble1"].stemDirection;
        this.player1ChatBubble.zOrder = 210;

        //ChatBubble 2
        this.player2ChatBubble.x = this.pileLayout["chatBubble2"].x;
        this.player2ChatBubble.y = this.pileLayout["chatBubble2"].y;
        //this.player2ChatBubble.stemDirection  = this.pileLayout["chatBubble2"].stemDirection;
        this.player2ChatBubble.zOrder = 210;

        this.textPopUpMessageBottom.x = this.pileLayout["pointPopup1"].x;
        this.textPopUpMessageBottom.y = this.pileLayout["pointPopup1"].y;
        this.textPopUpMessageBottom.zOrder = 200;

        this.textPopUpMessageTop.x = this.pileLayout["pointPopup2"].x;
        this.textPopUpMessageTop.y = this.pileLayout["pointPopup2"].y;
        this.textPopUpMessageTop.zOrder = 200;



        this.showMatchPoints();
        this.showTurnIndicator(this.cribbage.playerTurn);

        // //create text - state
        // let state = this.cribbage.currentState;
        // this.textState.x = 20;
        // this.textState.y = -50;
        // this.textState.text = state;

        //ready button
        let canReady = this.cribbage.canReady(this.tablePosition);
        this.btnReady.visible = canReady;

        //check for state change
        if (this.state !== this.cribbage.currentState) {
            this.state = this.cribbage.currentState;
            this.onStateChanged();
        }

        this.isDirty = true;
    }
    start() {
        //this.cribbage.action("start");
        //note: trigger onStateChange on the UI - resuming will not trigger it and thus not show some ui elements needed
        this.onStateChanged();
        this.update(true);
    }

    error(cardUI) {
        console.error(`cardUI id: ${cardUI.id} should never be at this location with this targetX: ${cardUI.targetX}`);
        // let cardUIData = {
        //     id:cardUI.id,
        //     targetX: cardUI.targetX,
        //     targetY: cardUI.targetY,
        //     x: cardUI.x,
        //     y: cardUI.y
        // }
        // console.error(cardUIData);
        // let cribbageData = this.cribbage.save();
        // console.error(cribbageData);
        // debugger;
    }
    playSound(id) {
        if (this.audio) {
            this.audio.play(id);
        }
        // const sound = PIXI.sound.find(id);
        // //multi play a not preloaded resource cause crash - https://github.com/pixijs/sound/issues/71
        // if (sound && sound.isLoaded) {
        //     PIXI.sound.play(id);
        // }
    }
    update(force) {


        if (force) this.isDirty = true;

        //this.stage (containter) is dirty, before this was the pixi containter now it has a property stage for pixi containter
        //could change game engine to look at scene.stage and push all this.dirty to the this.stage (containter)
        if (this.stage.isDirty) {
            this.stage.isDirty = false;
            this.isDirty = true;
        }

        //get tick.  This will also tick the players to play if they can without using timers
        if (this.cribbage)
            this.cribbage.tick();


        //update ui needed, else sleep. event or click to wake up.
        //animation until nothing needs animation (each animation call return true if more animations are needed. or a function call to check. 
        //or timer

        if (this.cardsUI.hasCardMoved()) {
            this.playSound("CardClick");
        }

        let cIsDirty = this.cardsUI.update(force);
        if (cIsDirty)
            this.isDirty = true;
        else {
            // this.validateTweenEnd();
        }

        let bIsDirty = this.cribbageBoard.update();
        if (bIsDirty) this.isDirty = true;

        let ptIsDirty = this.textPopUpMessageTop.update();
        if (ptIsDirty) this.isDirty = true;

        let pbIsDirty = this.textPopUpMessageBottom.update();
        if (pbIsDirty) this.isDirty = true;

        let tttIsDirty = this.player1TurnTimer.update();
        if (tttIsDirty) this.isDirty = true;

        let ttbIsDirty = this.player2TurnTimer.update();
        if (ttbIsDirty) this.isDirty = true;

        let cbtIsDirty = this.player1ChatBubble.update();
        if (cbtIsDirty) this.isDirty = true;

        let cbbIsDirty = this.player2ChatBubble.update();
        if (cbbIsDirty) this.isDirty = true;



        //should not be updating profile pic texture every frame 
        // let ps1IsDirty = this.player1Scoreboard.update();
        // if (ps1IsDirty) this.isDirty = true;

        // let ps2IsDirty = this.player2Scoreboard.update();
        // if (ps2IsDirty) this.isDirty = true;

        // // //if (this.debug) {
        //     this.validateCardPileZ();
        //      this.validateTweenEnd();
        //      this.validateCardTargetX();
        // // //}
    }
    render() {
        this.isDirty = false;
    }

    /////user input////////////////
    onCardTouched(event) {
        let cardId = event.currentTarget.id;

        //todo: on crib state, stage/select the cards. play is playing to the crib
        let state = this.cribbage.currentState;
        if (state === "crib") {
            this.cribbage.action("select", cardId, this.tablePosition);
        } else {
            this.cribbage.action("play", cardId, this.tablePosition);
        }
    }
    onClick(event) {
        this.nextAction(this.tablePosition);
        this.isDirty = true;
    }
    btnConfirm_onClick() {
        this.cribbage.action("confirm", null, this.tablePosition);
    }
    btnSort_onClick() {
        this.cribbage.action("sort", null, this.tablePosition);
    }

    btnReady_onClick() {
        this.cribbage.action("start", null, this.tablePosition);
    }

    buttonExit_onClick() {

        //rules to allow quit without penalty
        if (this.cribbage) {
            let allowQuit = this.cribbage.canQuit(this.tablePosition);
            let level = this.cribbage.level;
            if (!allowQuit && level === "Online") {
                let dialogBox = new DialogBox("Quit?", "You will recieve a loss if you quit without finishing the game.");
                dialogBox.x = (this.stageWidth / 2);
                dialogBox.y = (this.stageHeight / 2);
                dialogBox.zOrder = 100;
                dialogBox.onConfirm = this.quit.bind(this);
                this.stage.addChild(dialogBox);
                return;
            }
        }

        this.quit("Exit");
        return;

    }
    quit(reason) {
        this.cribbage.action("quit", reason, this.tablePosition);
        this.app.quitGame();
        this.shutdown();
    }
    gameOver_onRematch() {
        this.cribbage.action("playAgain", null, this.tablePosition);
    }
    gameOver_onClick() {
        this.app.quitGame();
    }
    gameOver_onDetails() {
        this.showMatchDetails();
    }
    reportButton_onClick() {
        this.muteChat(true);

        let player = null;
        if (this.tablePosition === "player1")
            player = this.cribbage.player2;
        if (this.tablePosition === "player2")
            player = this.cribbage.player1;

        if (player) {
            this.app.blockPlayer(player.id, player.name);
        }
    }
    buttonAddFriend_onClick() {
        let invitee = null;
        if (this.tablePosition === "player1")
            invitee = this.cribbage.player2;
        if (this.tablePosition === "player2")
            invitee = this.cribbage.player1;
        this.app.addFriend(invitee);
    }
    buttonMute_onClick() {
        //this.showRoundSummary() ;
        //this.showGameOver() ;
        //this.cribbage.action("quit", null, this.tablePosition);
        this.muteAudio(!this.isAudioMuted);
    }
    buttonQuit_onClick() { //quit and not leave
        this.cribbage.action("quit", null, this.tablePosition);
    }
    buttonChat_onClick() {
        // this.chatSelection.visible = true;
        // this.isDirty = true;
        this.app.showChat(this.cribbage.allowFullChat);
    }
    chatSelection_onSelect(value) {
        //send action to cribbage core and add event listener for it as player position of ui
        this.cribbage.action("chat", value, this.tablePosition);
    }
    player1Scoreboard_onClick(event) {
        // // this.showGameOver();
        // //event.stopPropagation();
        // // this.player1ChatBubble.show("Hello Abby");
        // //this.cribbage.action("chat", "Hello Abby", "player1");
        // if (this.tablePosition === "player1") {
        //     this.chatSelection.visible = true;
        //     this.isDirty = true;
        // }
        if (this.tablePosition === "player1") {
            this.app.showChat(this.cribbage.allowFullChat);
        } else {
            this.muteChat(!this.isChatMuted);
        }
    }
    player2Scoreboard_onClick(event) {
        // //// //this.showHandDetails("player2", "Computer's Hand");
        // //this.showRoundSummary();
        // //event.stopPropagation();

        // // this.chatSelection.visible = true;
        // // this.isDirty = true;
        // //  this.cribbage.action("chat", "Hello Abby", "player2");
        // if (this.tablePosition === "player2") {
        //     this.chatSelection.visible = true;
        //     this.isDirty = true;
        // }
        //this.onChat("Mooooo","player2");
        if (this.tablePosition === "player2") {
            this.app.showChat(this.cribbage.allowFullChat);
        } else {
            this.muteChat(!this.isChatMuted);
        }

    }
    btnHand1_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showHandDetails("player1", round);

        event.stopPropagation();
    }
    btnHand2_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showHandDetails("player2", round);
        event.stopPropagation();
    }
    btnCrib1_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showCribDetails("crib", round, "Crib");
        event.stopPropagation();
    }
    btnCrib2_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showCribDetails("crib", round, "Crib");
        event.stopPropagation();
    }
    btnNext_onClick() {
        this.nextAction(this.tablePosition);
    }
    btnExplain_onClick(event) {
        // this.showHandDetails("crib", "Crib");
        // this.showHandDetails("player2", "Computer's Hand");
        // this.showHandDetails("player1", "Players's Hand");
        this.showRoundDetails();
        event.stopPropagation();
    }
    btnAnalyzeHand_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showAnalyzeHand(round);
        event.stopPropagation();
    }
    ////////ui helpers///////////////
    nextAction(player) {
        if (!this.cribbage) return;
        if (!this.cribbage.getActions) return;
        let actions = this.cribbage.getActions(player).map(x => x.command);
        if (actions.includes("next") === true) {
            this.cribbage.action("next", null, player);
        }
        this.isDirty = true;
    }
    muteChat(isMuted) {
        this.isChatMuted = isMuted;
        this.updateLayout();
        this.isDirty = true;
    }
    muteAudio(isMuted) {
        this.isAudioMuted = isMuted;
        this.app.muteSet(isMuted);
        this.updateLayout();
        this.isDirty = true;
    }
    showHandDetails(player, round) {

        let summary = this.cribbage.scoreHandDetail(player, round);

        let title = summary.name + "'s Hand";
        if (summary.name === "You") title = "Your Hand";
        //scoreDetails
        this.scoreDetails = new ScoreDetails(title, summary.starterCard, summary.hand, summary.points);
        this.scoreDetails.x = (this.stageWidth / 2);
        this.scoreDetails.y = (this.stageHeight / 2);
        this.scoreDetails.zOrder = 110;
        this.stage.addChild(this.scoreDetails);

        this.isDirty = true;
    }
    showCribDetails(player, round, title) {

        let summary = this.cribbage.scoreCribDetail(round);

        //scoreDetails
        this.scoreDetails = new ScoreDetails(title, summary.starterCard, summary.hand, summary.points);
        this.scoreDetails.x = (this.stageWidth / 2);
        this.scoreDetails.y = (this.stageHeight / 2);
        this.scoreDetails.zOrder = 110;
        this.stage.addChild(this.scoreDetails);

        this.isDirty = true;
    }
    showRoundSummaryWindow(player) {
        if (!player) player = this.tablePosition;

        let scoreSummary = this.cribbage.roundSummary();

        //round summary popup
        this.roundSummaryWindow = new RoundSummaryWindow();
        this.roundSummaryWindow.x = (this.stageWidth / 2);
        this.roundSummaryWindow.y = (this.stageHeight / 2);
        this.roundSummaryWindow.zOrder = 110;
        this.stage.addChild(this.roundSummaryWindow);

        //populate
        this.roundSummaryWindow.updateScore(scoreSummary);
        this.roundSummaryWindow.onAnalyze = this.showAnalyzeHand.bind(this);

        this.isDirty = true;
    }
    showMatchSummary() {
        let scoreSummary = this.cribbage.matchSummary();

        //round summary popup
        this.matchSummary = new MatchSummary();
        this.matchSummary.x = (this.stageWidth / 2);
        this.matchSummary.y = (this.stageHeight / 2);
        this.matchSummary.zOrder = 110;
        this.stage.addChild(this.matchSummary);

        //populate
        this.matchSummary.updateScore(scoreSummary);

        this.isDirty = true;
    }
    showRoundSummary(player, hideContinue) {
        if (!player) player = this.tablePosition;

        //get data
        let scoreSummary = this.cribbage.roundSummary();

        //populate
        this.roundSummary.tablePosition = player;
        this.roundSummary.scoreSummary = scoreSummary;
        this.roundSummary.hideContinue = hideContinue;
        this.roundSummary.updateLayout();

        //show round summary 
        this.roundSummary.visible = true;
        this.isDirty = true;
    }
    showHandCount() {
        //get data
        let scoreSummary = this.cribbage.roundSummary();

        //show hand points
        let hand1Score = scoreSummary["player1"] ? scoreSummary["player1"].hand : 0;
        let hand2Score = scoreSummary["player2"] ? scoreSummary["player2"].hand : 0;
        let crib1Score = scoreSummary["player1"] ? scoreSummary["player1"].crib : 0;
        let crib2Score = scoreSummary["player2"] ? scoreSummary["player2"].crib : 0;
        let dealer = this.cribbage.dealer;

        this.btnScoreHand1.text = hand1Score + " 🔎";
        this.btnScoreHand2.text = hand2Score + " 🔎";
        this.btnScoreCrib1.text = crib1Score + " 🔎";
        this.btnScoreCrib2.text = crib2Score + " 🔎";

        this.btnScoreHand1.visible = true;
        this.btnScoreHand2.visible = true;
        if (dealer === "player1") this.btnScoreCrib1.visible = true;
        if (dealer === "player2") this.btnScoreCrib2.visible = true;

        this.isDirty = true;
    }
    showAnalyzeHandSummary(player) {
        if (!player) player = this.tablePosition;
        let optimalAvgHand = this.cribbage.analyzeSeletedHand(player);
        this.handAnalyzerPanel.analyzeScore = optimalAvgHand;
        this.handAnalyzerPanel.updateLayout();
        this.handAnalyzerPanel.visible = true;
    }
    showAnalyzeHand(round, player) {
        if (!player) player = this.tablePosition;
        if (typeof round !== 'number') round = this.cribbage.roundNumber;
        let analysis = this.cribbage.analyzeHand(player, round);
        this.app.showAnalyzeHand(analysis);
    }
    showMatchPoints() {
        let matchPoints = this.cribbage.matchPoints;

        //needs to be called only on summary point updates for hand / crib
        this.cribbageBoard.updateScore(matchPoints["player1"], matchPoints["player2"]);

        //this.scoreboard.updateScore(matchPoints["player1"] || 0, matchPoints["player2"] || 0)

        this.player1Scoreboard.updateScore(matchPoints["player1"] || 0)
        this.player2Scoreboard.updateScore(matchPoints["player2"] || 0)
    }
    showGameOver() {
        //play sound
        this.playSound("AchivementSound");

        //dont show on test
        if (this.isTest()) return;

        let matchPoints = this.cribbage.matchPoints;
        let isSkunked = this.cribbage.isSkunked;
        let message = "You win!";
        let player1 = this.cribbage.player1 ? this.cribbage.player1.name : "You";
        let player2 = this.cribbage.player2 ? this.cribbage.player2.name : "Computer";

        let allowRematch = this.cribbage.allowRematch;
        let readyPlayer1 = this.cribbage.readyPlayer1;
        let readyPlayer2 = this.cribbage.readyPlayer2;

        let matchWinnerName = "";
        if (this.cribbage.matchWinner === "player1") matchWinnerName = player1;
        if (this.cribbage.matchWinner === "player2") matchWinnerName = player2;

        message = matchWinnerName + " wins!";
        if (matchWinnerName === "You") message = "You win!";

        this.gameOver.message = message;
        this.gameOver.scorePlayer1 = matchPoints["player1"];
        this.gameOver.scorePlayer2 = matchPoints["player2"];
        this.gameOver.player1Name = player1;
        this.gameOver.player2Name = player2;
        this.gameOver.readyPlayer1 = readyPlayer1;
        this.gameOver.readyPlayer2 = readyPlayer2;
        this.gameOver.isSkunked = isSkunked;
        this.gameOver.allowRematch = allowRematch;
        this.gameOver.update();
        this.gameOver.visible = true;

        this.isDirty = true;


    }
    isTest() {
        // let player = this.tablePosition == "player1" ? this.cribbage.player1 : this.cribbage.player2;
        // let isTest = false;
        // if (player && player.behavior === "test") isTest = true;
        // return isTest;

        if (this.cribbage.debugUI == true)
            return true;

        //return false;
    }
    showRoundDetails(round) {

        this.showCribDetails("crib", round, "Crib");
        this.showHandDetails("player2", round, "Computer's Hand");
        this.showHandDetails("player1", round, "Players's Hand");

        this.isDirty = true;
    }
    showMatchDetails(round) {
        this.showMatchSummary();
        // this.showRoundSummaryWindow();
        // this.showCribDetails("crib", round, "Crib");
        // this.showHandDetails("player2", round, "Computer's Hand");
        // this.showHandDetails("player1", round, "Players's Hand");
        this.isDirty = true;
    }
    showPointPopUp(player, message) {

        //Show popup
        if (player == "player1") {
            this.textPopUpMessageBottom.show(message);
        }
        if (player == "player2") {
            this.textPopUpMessageTop.show(message);
        }

        //play sound
        this.playSound("PointSound");
    }

    showTurnIndicator(playerTurn) {
        this.player1TurnIndicator.visible = false;
        this.player2TurnIndicator.visible = false;
        this.player1TurnTimer.visible = false;
        this.player2TurnTimer.visible = false;

        if (playerTurn === "player1") {
            this.player1TurnIndicator.visible = true;
            this.player1TurnTimer.visible = true;
        }
        if (playerTurn === "player2") {
            this.player2TurnIndicator.visible = true;
            this.player2TurnTimer.visible = true;
        }

        this.isDirty = true;
    }
    ////////events from model///////////
    onAwardPoints(pointLogArray) {
        if (!pointLogArray) return false;
        if (pointLogArray.length == 0) return false;

        let showGrouped = false;
        let state = pointLogArray[0].state; //this.cribbage.currentState
        if (state === "showNonDealerHand" || state === "showDealerHand" || state === "showCrib")
            showGrouped = true;

        //note: could show each delayed so all dont show at once

        //single point log
        if (!showGrouped) {
            let messages = [];
            for (let i = 0; i < pointLogArray.length; i++) {
                let p = pointLogArray[i];
                //this.showPointPopUp(p.player, p.points, p.reason,);
                let message = '+' + p.points + '  ' + p.reason;
                messages.push(message);
            }
            let player = pointLogArray[0].player;
            let message = messages.join('\n');
            this.showPointPopUp(player, message);
        }
        // //multiple point log: show grouped name as a single point ui popup
        // if (showGrouped) {
        //     let points = pointLogArray.reduce(function (total, item) {
        //         return total + item.points;
        //     }, 0);
        //     let reason = pointLogArray[0].pile;
        //     let player = pointLogArray[0].player;
        //     //this.showPointPopUp(player, points, reason);
        //     this.showPointPopUp(player, '+' + points + '  ' + reason);
        // }


        //{"event":"awardPointsArray","value":[{"points":2,"player":"player2","reason":"fifteen two","pile":"crib","cards":["5h","13d"],"state":"show","round":2}],"timestamp":169.876}
        ////{"event":"awardPoints","value":{"points":2,"player":"player2","reason":"fifteen two","pile":"crib","cards":["5h","13d"],"state":"show","round":2},"timestamp":169.876}
    }
    onHandPoints(message, player) {
        this.showPointPopUp(player, '+' + message);
    }
    onMatchPoints(matchPoints) {
        this.showMatchPoints();
    }
    onStateChanged() {
        //OnStateChange
        let state = this.cribbage.currentState;
        let sortHands = this.cribbage.sortHands;
        //this.textState.text = state;

        this.textInstructionsBottom.text = this.cribbage.messagePlayer1;
        this.textInstructionsTop.text = this.cribbage.messagePlayer2;


        this.showTurnIndicator(this.cribbage.playerTurn);
        if (state === "showNonDealerHand") {

        }
        if (state === "showDealerHand") {

        }
        if (state === "showCrib") {

        }
        if (state === "endRound") {
            //this.showRoundSummary();
            //this.playSound("WinSound");
            //this.showRoundEnd();
            this.showRoundSummary();
            //this.showHandCount();
            //this.showAnalyzeHandSummary();
            // this.btnScoreHand1.visible = true;
            // this.btnScoreHand2.visible = true;
            // this.btnScoreCrib1.visible = true;
            // this.btnScoreCrib2.visible = false;
        } else {
            this.roundSummary.visible = false;
            //this.handAnalyzerPanel.visible = false;

            this.btnScoreHand1.visible = false;
            this.btnScoreHand2.visible = false;
            this.btnScoreCrib1.visible = false;
            this.btnScoreCrib2.visible = false;
        }
        if (state === "startRound") {

        }
        if (state === "crib" && !sortHands) {
            this.btnSort.visible = true;
        } else {
            this.btnSort.visible = false;
        }
        if (state === "play") {
            //this.roundSummary.visible = false;
        }
        if (state === "endMatch") {
            this.showGameOver();
            this.showRoundSummary(null, true);
        } else {
            // this.gameOver.visible = false;
        }
        if (state === "preGame") {
            //this.roundSummary.visible = false;
            this.gameOver.visible = false;
        }
        //this.handAnalyzerPanel.visible = true;  
        //this.gameOver.visible = true;
        // this.showRoundSummary();
        //this.gameOver.visible = true;
        //this.updateLayout();

        this.isDirty = true;
    }
    onActionStart(args) {
        // this.textInstructionsTop.text = "";
        // this.textInstructionsBottom.text = "";
        //this.textPopUpMessageBottom.hide();
        // this.textPopUpMessageTop.hide();
    }
    onActionEnded(args) {
        this.textPlayCount.text = this.cribbage.playCount;


        this.textInstructionsBottom.text = this.cribbage.messagePlayer1;
        this.textInstructionsTop.text = this.cribbage.messagePlayer2;

        this.showTurnIndicator(this.cribbage.playerTurn);


        this.textInvalidMoveTop.text = '';
        this.textInvalidMoveBottom.text = '';

        let canConfirm = this.cribbage.canConfirm(this.tablePosition);
        this.btnConfirm.visible = canConfirm;

        let canReady = this.cribbage.canReady(this.tablePosition);
        this.btnReady.visible = canReady;

        let canSort = this.cribbage.canSort(this.tablePosition);
        this.btnSort.visible = canSort;

        //show ready indicator
        //todo: delete " this.cribbage.readyPlayer1" after all have upgraded 2/11/2020
        //let readyPlayer1 = this.cribbage.readyPlayer1;
        //let readyPlayer2 = this.cribbage.readyPlayer2;
        //let readyPlayer1 = this.cribbage.player1 ? this.cribbage.player1.ready : false;
        //let readyPlayer2 = this.cribbage.player2 ? this.cribbage.player2.ready : false;
        let player1 = this.cribbage.player1;
        let player2 = this.cribbage.player2;
        let readyPlayer1 = player1 ? (player1.ready || player1.readyPlayer1) : false;
        let readyPlayer2 = player2 ? (player2.ready || player2.readyPlayer2) : false;

        this.gameOver.readyPlayer1 = readyPlayer1;
        this.gameOver.readyPlayer2 = readyPlayer2;
        this.gameOver.update();

        //show ready indicator
        this.roundSummary.readyPlayer1 = readyPlayer1;
        this.roundSummary.readyPlayer2 = readyPlayer2;
        this.roundSummary.update();

        this.isDirty = true;
    }
    onInvalidMove(msg, player) {
        if (player === "player1")
            this.textInvalidMoveBottom.text = msg;
        if (player === "player2")
            this.textInvalidMoveTop.text = msg;
        this.isDirty = true;
    }
    onMessage(msg, player) {
        // if (player === "player1" || player === undefined)
        //     this.textInstructionsBottom.text = msg;
        // else
        //     this.textInstructionsTop.text = msg;
    }
    onCardMoved(args) {
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);
        // this.playSound("CardClick");

        this.isDirty = true;
    }
    onJoin(args) {
        // //todo: should matching local ui to controlling playe be done here?
        // if (this.cribbage.player1 && this.tablePosition === this.cribbage.player1.name) {
        //     this.tablePosition = "player1";
        // }
        // if (this.cribbage.player2 && this.tablePosition === this.cribbage.player2.name) {
        //     this.tablePosition = "player2";
        // }
        this.onStateChanged();
        this.updateLayout();
        this.isDirty = true;
    }
    onLeave(args) {
        this.updateLayout();
        this.isDirty = true;
    }
    onDisconnect() {
        this.updateLayout();
        this.isDirty = true;
    }
    onStartPlayTimer(duration, player) {
        if (player === "player1")
            this.player1TurnTimer.show(duration);
        if (player === "player2")
            this.player2TurnTimer.show(duration);
    }
    onChat(message, player) {
        if (this.isChatMuted) {
            if (this.tablePosition != player) {
                return;
            }
        }
        if (this.app && this.app.translate) {
            message = this.app.translate(message);
        }

        if (player === "player1")
            this.player1ChatBubble.show(message);
        if (player === "player2")
            this.player2ChatBubble.show(message);
    }
    onData() {
        this.updateLayout();
        this.isDirty = true;
    }
}